<template>
  <!-- 社区首页 -->
  <div>
    <div class="community">
      <div class="head_box">
        <div class="comsearch_content">
          <input
            type="text"
            placeholder="输入关键字"
            class="community_search"
            v-model="keyword"
            @keyup.enter="search_kw"
          />
          <p class="search_push" @click="search_kw"></p>
        </div>
        <div class="ask" @click="tickie9">
          <span></span>我要提问
        </div>
      </div>
      <div class="back" @click="goback" v-show="issearch">
        <span></span>返回
      </div>
      <div class="ask_content" v-show="isask">
        <p class="closetagbox" @click="colseask" alt></p>
        <!-- <ask v-on:funct="successask" :clearask="clearask"></ask> -->
      </div>
      <div class="community_content">
        <div class="content_head" v-show="!issearch">
          <div class="head_content">
            <p class="chioce_head">
              {{navtitle}}
              <span></span>
            </p>
            <ul class="head_choice">
              <li @click="choicetype(1)">全部</li>
              <li @click="choicetype(2)">问答</li>
              <li @click="choicetype(3)">标注</li>
            </ul>
          </div>
        </div>
        <div class="content_searchhead" @click="loadlist" v-show="issearch">
          <p>
            搜索到
            <span>{{search_count}}条“{{keyword_wd}}”</span>相关信息
          </p>
        </div>
        <div
          class="questionList infinite-list"
          ref="scrollList"
          v-infinite-scroll="pushnext"
          infinite-scroll-disabled="isquestionall"
          infinite-scroll-distance="10"
          infinite-scroll-immediate="false"
        >
          <div v-for="(item,index) in questionArr" class="questionli" :key="index" v-if="item.type!=3">
            <div v-if="item.type==1" class="question_li">
              <p v-show="navtype!=2&&navtype!=3" class="answer_t type_t">问答</p>
              <p class="questiontitle" @click="goquestiondetail(item,2)">{{item.question_title}}</p>
              <!-- 问题有回答 -->
              <div v-if="item.answer.answer_id" class="hasanswer">
                <!-- 回答是否有图片 -->
                <div v-if="item.answer.img" class="haspicture">
                  <div
                    alt
                    class="hasimage"
                    :style=" {backgroundImage:'url('+item.answer.img+')'}"
                    style="background-size: cover;background-position: center center;"
                    v-show="!item.answer.is_detail"
                    @click="lookmore(index,item)"
                  ></div>
                  <div
                    class="answercon"
                    @click="lookmore(index,item)"
                    v-show="!item.answer.is_detail"
                  >
                    <span class="answer_name">{{item.answer.user_name}}：</span>
                    {{item.answer.content}}
                    <span class="hasmore">
                      显示全部
                      <sub></sub>
                    </span>
                  </div>
                  <div class="ishasmore" v-show="item.answer.is_detail">
                    <span class="answer_name_detail">
                      <img :src="item.answer.head_img" alt />
                      {{item.answer.user_name}}
                    </span>
                    <viewer>
                      <pre
                        @click="logimg($event)"
                        class="detail_content"
                        v-html="item.answer.detail_content"
                      ></pre>
                    </viewer>
                  </div>
                </div>
                <div v-else class="nopicture">
                  <div
                    class="nopircontent"
                    @click="lookmore(index,item)"
                    v-show="!item.answer.is_detail"
                  >
                    <span class="answer_name">{{item.answer.user_name}}：</span>
                    {{item.answer.content}}
                    <span class="hasmore">
                      显示全部
                      <sub></sub>
                    </span>
                  </div>
                  <div class="nopircontent2" v-show="item.answer.is_detail">
                    <span class="answer_name_detail">
                      <img :src="item.answer.head_img" alt />
                      {{item.answer.user_name}}
                    </span>
                    <pre
                      @click="logimg($event)"
                      class="detail_content"
                      v-html="item.answer.detail_content"
                    ></pre>
                  </div>
                </div>
                <p class="answer_time" v-show="item.answer.is_detail">发布于{{item.answer.answer_time}}</p>
                <div class="answer_evaluate">
                  <p
                    class="answer_star"
                    v-show="!item.answer.is_star"
                    @click="tostar(item.answer.answer_id,index,item.type)"
                  >
                    <strong class="star_span"></strong>
                    <span v-show="item.answer.star_count!=0">{{item.answer.star_count}}个</span>点赞
                  </p>
                  <p
                    v-show="item.answer.is_star"
                    @click="cancelstar(item.answer.answer_id,index,item.type)"
                    style="color:#D55D3A;"
                    class="answer_cancelstar"
                  >
                    <img src="../../assets/community/hand_icon_does.png" alt />
                    {{item.answer.star_count}}个点赞
                  </p>
                  <p
                    class="answer_comment"
                    v-show="!commentisArr[index]"
                    @click="setcomment(index,item.answer.answer_id,1,item.type)"
                  >
                    <strong></strong>
                    <span v-show="item.answer.comment_count!=0">{{item.answer.comment_count}}条</span>评论
                  </p>
                  <p
                    class="answer_comment"
                    v-show="commentisArr[index]"
                    @click="setcomment(index,item.answer.answer_id,2,item.type)"
                  >
                    <strong></strong>收起评论
                  </p>
                  <div
                    class="closeanswer"
                    v-show="item.answer.is_detail"
                    @click="item.answer.is_detail=!item.answer.is_detail"
                  >
                    收起回答
                    <span></span>
                  </div>
                </div>
                <div class="answer_comments" v-show="commentisArr[index]">
                  <p
                    class="comment_count"
                    v-if="commentArr[index].comments.length != 0"
                  >{{commentArr[index].total_count}}条评论</p>
                  <div v-show="commentArr[index].comments.length != 0">
                    <div
                      class="comment_li"
                      v-for="(citem,cindex) in commentArr[index].comments"
                      :key="cindex"
                    >
                      <p class="comment_username">{{citem.user_name}}</p>
                      <pre class="comment_comtent" v-html="citem.content"></pre>
                      <p class="comment_time">{{citem.create_time}}</p>
                      <p
                        class="comment_detele"
                        v-if="userid == citem.user_id"
                        @click="comment_delete(item.answer.answer_id,citem.comment_id,index,item.type)"
                      >删除</p>
                    </div>
                  </div>
                  <div v-if="commentArr[index].comments.length == 0" class="notcomment">
                    <p class="comment_count">还没有评论</p>
                    <!-- <span>没有评论~<span>现在去添加第一个吧~</span></p> -->
                  </div>
                  <div class="pagination" v-if="commentArr[index].total_pages>1">
                    <el-pagination
                      @prev-click="handlePre($event,index,item)"
                      @next-click="handleNext($event,index,item)"
                      @current-change="changePage($event,index,item)"
                      prev-text="上一页"
                      next-text="下一页"
                      :current-page="commentArr[index].current_page"
                      layout="prev, pager, next"
                      :page-size="1"
                      :total="commentArr[index].total_pages"
                    ></el-pagination>
                  </div>
                  <div class="comment_answer">
                    <!-- <input type="text" placeholder="写下你的评论..." v-model="item.commentsub" /> -->
                    <el-input
                      class="comment_input"
                      type="textarea"
                      autosize
                      placeholder="写下你的评论..."
                      v-model="item.commentsub"
                    ></el-input>
                    <button @click="comment_submit(item,index)">发表</button>
                  </div>
                </div>
              </div>
              <div v-else class="iwantanswer" @click="tickie9">
                <span></span>我要回答
              </div>
            </div>
            <!-- 标注部分 -->
            <div v-else-if="item.type==2" class="question_li">
              <p v-show="navtype!=2&&navtype!=3" class="tag_t type_t">标注</p>
              <p class="tag_name_detail">
                <img :src="item.tag.head_img" alt />
                {{item.tag.user_name}}
              </p>
              <p
                :class="[navtype==3?'tag_bookname2':'tag_bookname']"
                class="tag_bookname"
                @click="gopicture(item.tag)"
              >《{{item.tag.book_name}}》</p>
              <p
                class="tag_content"
                v-show="!item.tag.is_detail"
                @click="item.tag.is_detail=!item.tag.is_detail"
              >
                {{item.tag.detail_content}}
                <span class="hasmore">
                  显示全部
                  <sub></sub>
                </span>
              </p>
              <div class="tag_content" v-show="item.tag.is_detail">
                <viewer>
                  <!-- <img v-for="(src,index) in photo" :src="src" :key="index" :onerror="errorImg" /> -->
                  <img
                    :src="item.tag.img"
                    ondragstart="return false;"
                    @click="open_img($event,item.tag.img)"
                  />
                </viewer>
                <p>{{item.tag.detail_content}}</p>
              </div>
              <div class="answer_evaluate">
                <!-- {{item.tag.is_star}} -->
                <p
                  class="answer_star"
                  v-show="!item.tag.is_star"
                  @click="tostar(item.tag.tag_id,index,item.type)"
                >
                  <strong class="star_span"></strong>
                  <span v-show="item.tag.star_count!=0">{{item.tag.star_count}}个</span>点赞
                </p>
                <p
                  v-show="item.tag.is_star"
                  @click="cancelstar(item.tag.tag_id,index,item.type)"
                  style="color:#D55D3A;"
                  class="answer_cancelstar"
                >
                  <img src="../../assets/community/hand_icon_does.png" alt />
                  {{item.tag.star_count}}个点赞
                </p>
                <p
                  class="answer_comment"
                  v-show="!commentisArr[index]"
                  @click="setcomment(index,item.tag.tag_id,1,item.type)"
                >
                  <strong></strong>
                  <span v-show="item.tag.comment_count!=0">{{item.tag.comment_count}}条</span>评论
                </p>
                <p
                  class="answer_comment"
                  v-show="commentisArr[index]"
                  @click="setcomment(index,item.tag.tag_id,2,item.type)"
                >
                  <strong></strong>收起评论
                </p>
                <p
                  class="delete_tag"
                  v-if="userid==item.tag.user_id"
                  @click="open_delettag(item.tag_id)"
                >
                  <!-- @click="delete_tag(item.tag_id)" -->
                  <span></span>删除
                </p>
                <div
                  class="closeanswer"
                  v-show="item.tag.is_detail"
                  @click="item.tag.is_detail=!item.tag.is_detail"
                >
                  收起回答
                  <span></span>
                </div>
              </div>
              <div class="answer_comments" v-show="commentisArr[index]">
                <p
                  class="comment_count"
                  v-if="commentArr[index].comments.length != 0"
                >{{commentArr[index].total_count}}条评论</p>
                <div v-show="commentArr[index].comments.length != 0">
                  <div
                    class="comment_li"
                    v-for="(citem,cindex) in commentArr[index].comments"
                    :key="cindex"
                  >
                    <p class="comment_username">{{citem.user_name}}</p>
                    <pre class="comment_comtent" v-html="citem.content"></pre>
                    <p class="comment_time">{{citem.create_time}}</p>
                    <p
                      class="comment_detele"
                      v-if="userid == citem.user_id"
                      @click="comment_delete(item.tag.tag_id,citem.comment_id,index,item.type)"
                    >删除</p>
                  </div>
                </div>
                <div v-if="commentArr[index].comments.length == 0" class="notcomment">
                  <p class="comment_count">还没有评论</p>
                  <!-- <span>没有评论~<span>现在去添加第一个吧~</span></p> -->
                </div>
                <div class="pagination" v-if="commentArr[index].total_pages>1">
                  <el-pagination
                    @prev-click="handlePre($event,index,item)"
                    @next-click="handleNext($event,index,item)"
                    @current-change="changePage($event,index,item)"
                    prev-text="上一页"
                    next-text="下一页"
                    :current-page="commentArr[index].current_page"
                    layout="prev, pager, next"
                    :page-size="1"
                    :total="commentArr[index].total_pages"
                  ></el-pagination>
                </div>
                <div class="comment_answer">
                  <!-- <input type="text" placeholder="写下你的评论..." v-model="item.commentsub" /> -->
                  <el-input
                    class="comment_input"
                    type="textarea"
                    autosize
                    placeholder="写下你的评论..."
                    v-model="item.commentsub"
                  ></el-input>
                  <button @click="comment_submit(item,index)">发表</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="floatask" v-if="istopask&&!iswhite">
          <div class="iwantask" @click="tickie9">
            <p>我要提问</p>
          </div>
          <div v-show="isgotop" class="gotop" @click="gotop"></div>
        </div>
        <div v-if="!istopask&&!iswhite" class="iwantask_search" @click="tickie9">
          <p>我要提问</p>
        </div>
      </div>
    </div>
    <div class="dialog" v-show="dialogVisible">
      <div class="dialog_center">
        <p class="dialogtitle">仅是删除当前位置的标注</p>
        <div class="dialogconfirm">
          <p class="dialogfalse" @click="dialogVisible=!dialogVisible">现在取消</p>
          <p class="dialogtrue" @click="delete_tag">确认删除</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { addstamp } from "../../util/stamp";
import { distance } from "../../util/gettime";
// import Ask from "../public/aks.vue";
import opentoimg from "../public/open_img.vue";
import Viewer from "viewerjs";
import "viewerjs/dist/viewer.css";
export default {
  data() {
    return {
      userid: null,
      isask: false,
      currentpage: 1,
      pagesize: 10,
      total_pages: null,
      questionArr: [],
      commentisArr: [],
      commentArr: [],
      isquestionall: false,
      isgotop: false,
      bgimg: [
        require("../../assets/community/headimg/User_icon_1.png"),
        require("../../assets/community/headimg/User_icon_2.png"),
        require("../../assets/community/headimg/User_icon_3.png"),
        require("../../assets/community/headimg/User_icon_4.png")
      ],
      imgbg: [],
      keyword: null,
      issearch: false,
      keyword_wd: null,
      search_count: null,
      navtitle: "全部",
      navtype: 1,
      clearask: [],
      istopask: true,
      openimg: false,
      openimg_img: null,
      imgSrc: null,
      dialogVisible: false,
      delete_id: null,
      iswhite: false
    };
  },
  components: {
    // ask: Ask,
    opentoimg: opentoimg
  },
  created() {
    this.iswhite = this.$store.state.iswhitelist;
    this.userid = parseInt(this.$store.state.user_id);
    this.loadlist();
    if (this.$route.query.wd) {
      this.keyword = this.$route.query.wd;
      this.search_kw();
    }
  },
  mounted() {
    var that = this;
    var two = document.documentElement.clientHeight * 2;
    window.addEventListener("scroll", function(e) {
      var top = document.documentElement.scrollTop;
      if (top > two) {
        that.isgotop = true;
      } else {
        that.isgotop = false;
      }
    });
  },
  updated() {},
  methods: {
    IEVersion() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
      var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
      if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
          return 7;
        } else if (fIEVersion == 8) {
          return 8;
        } else if (fIEVersion == 9) {
          return 9;
        } else if (fIEVersion == 10) {
          return 10;
        } else {
          return 6; //IE版本<=7
        }
      } else if (isEdge) {
        return "edge"; //edge
      } else if (isIE11) {
        return 11; //IE11
      } else {
        return -1; //不是ie浏览器
      }
    },
    tickie9() {
      alert('系统升级中')
      // var iev = this.IEVersion();
      // console.log(iev)
      // if (
      //   iev == 6 ||
      //   iev == 7 ||
      //   iev == 8 ||
      //   iev == 9 ||
      //   iev == 10 ||
      //   iev == "edge"
      // ) {
      //   this.$message({
      //     message: "当前版本过低，请升级或更换chrome浏览器",
      //     type: "warning"
      //   });
      // }else{
      //   window.location.herf = 'about:bank'
      // }
    },
    logimg(e) {
      // if (e.target.nodeName === "IMG") {
      //   this.open_img(e,e.target.src);
      // }
    },
    open_delettag(id) {
      this.delete_id = id;
      this.dialogVisible = !this.dialogVisible;
    },
    // 查看原图
    open_img(e, img) {
      // this.openimg = !this.openimg;
      // this.openimg_img = img;
      // this.imgSrc = img
      // let viewer = new Viewer(e.target, {
      //   url:img,
      //   inline: true,
      //   viewed() {
      //     viewer.zoomTo(1);
      //   },
      // });
    },
    goback() {
      this.issearch = !this.issearch;
      this.currentpage = 1;
      this.search_count = 1;
      this.keyword = null;
      this.loadlist();
    },
    delete_tag() {
      var that = this;
      let params = {
        user_id: that.$store.state.user_id,
        type: "community",
        tag_ids: that.delete_id
      };
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      that.$axios.delete("tag", { params }).then(function(res) {
        if (res.data.status_code == 200) {
          that.dialogVisible = false;
          that.loadlist();
        }
      });
    },
    gopicture(tag) {
      var that = this;
      if (that.$store.state.user_id) {
        let params = {
          user_id: that.$store.state.user_id,
          volume_id: tag.volume_id
        };
        var sign = addstamp(params);
        delete params.token;
        params["sign"] = sign;
        that.$axios
          .get("/book/auth/" + tag.volume_id, {
            params
          })
          .then(res => {
            if (res.data.status_code !== 200) {
              alert("暂无查看权限，请联系管理员");
            } else {
              let pictureUrl = that.$router.resolve({
                path: "/picture",
                query: {
                  volume_id: tag.volume_id,
                  imd: tag.img_id
                }
              });
              window.open(pictureUrl.href, "_blank");
            }
          });
      } else {
        that.$router.push({ path: "/login" });
      }
    },
    colseask() {
      this.isask = !this.isask;
      this.clearask = {
        question: "",
        content: ""
      };
    },
    choicetype(type) {
      var oldtype = this.navtype;
      switch (type) {
        case 1:
          this.navtitle = "全部";
          this.navtype = 1;
          break;
        case 2:
          this.navtitle = "问答";
          this.navtype = 2;
          break;
        case 3:
          this.navtitle = "标注";
          this.navtype = 3;
          break;
      }
      this.currentpage = 1;
      if (oldtype != type) {
        this.loadlist();
      }
    },
    search_kw() {
      if (this.keyword != "" && this.keyword != null) {
        // console.log(this.keyword)
        this.issearch = true;
        this.currentpage = 1;
        this.keyword_wd = this.keyword;
        this.loadlist();
      }
    },
    comment_submit(item, index) {
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        content: item.commentsub
      };
      //   console.log(item.commentsub);
      var url = "";
      if (item.type == 1) {
        url = "community/" + item.answer.answer_id + "/comment";
        params.type = "answer";
        params.id = item.answer.answer_id;
      } else {
        url = "community/" + item.tag.tag_id + "/comment";
        params.type = "tag";
        params.id = item.tag.tag_id;
      }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      this.$axios.post(url, params).then(function(res) {
        // console.log(res)
        that.commentArr[index].current_page = 1;
        if (item.type == 1) {
          that.questionArr[index].answer.comment_count += 1;
          that.loadlistcomment(index, item.answer.answer_id, item.type);
        } else {
          that.questionArr[index].tag.comment_count += 1;
          that.loadlistcomment(index, item.tag.tag_id, item.type);
        }
        that.questionArr[index].commentsub = "";
      });
    },
    comment_delete(itemid, comment_id, index, type) {
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        comment_id: comment_id,
        id: itemid
      };
      if (type == 1) {
        params.type = "answer";
      } else {
        params.type = "tag";
      }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      let url = "community/" + itemid + "/comment";
      this.$axios.delete(url, { params }).then(function(res) {
        // console.log(res);
        // console.log(that.questionArr)
        if (type == 1) {
          that.questionArr[index].answer.comment_count -= 1;
        } else {
          that.questionArr[index].tag.comment_count -= 1;
        }
        that.commentArr[index].current_page = 1;
        that.loadlistcomment(index, itemid, type);
      });
    },
    loadlistcomment(index, id, type) {
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        page: this.commentArr[index].current_page,
        page_size: 15,
        id: id
      };
      if (type == 1) {
        params.type = "answer";
      } else {
        params.type = "tag";
      }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      // console.log(params)
      let url = "community/" + id + "/comments";
      // console.log(url)
      this.$axios.get(url, { params }).then(function(res) {
        // console.log(res)
        if (res.data.status_code == 200) {
          that.commentArr[index].current_page = res.data.data.current_page;
          that.commentArr[index].total_pages = res.data.data.total_pages;
          that.commentArr[index].total_count = res.data.data.total_count;
          that.commentArr[index].comments = res.data.data.comments;
          for (var i = 0; i < that.commentArr[index].comments.length; i++) {
            that.commentArr[index].comments[i].create_time = distance(
              that.commentArr[index].comments[i].create_time
            );
          }
        }
      });
    },
    gotop() {
      window.scrollTo(100, 0);
    },
    pushnext() {
      if (this.currentpage != this.total_pages) {
        this.currentpage += 1;
        this.loadlist();
      }
    },
    setcomment(index, id, num, type) {
      if (num == 1) {
        this.$set(this.commentisArr, index, true);
        this.loadlistcomment(index, id, type);
      } else {
        this.$set(this.commentisArr, index, false);
      }
    },
    successask(data) {
      this.isask = data[0];
      this.$message({
        message: "问题发布成功！",
        type: "success"
      });
      // this.$router.push({
      //   path: "/questionDetails",
      //   query: {
      //     qd: data[1]
      //   }
      // });
      $("body").css({ overflow: "auto", "margin-right": "0px" });
    },
    loadlist() {
      let that = this;
      let params = {};
      if (this.keyword != "" && this.keyword != null) {
        params = {
          user_id: this.userid,
          page: this.currentpage,
          page_size: this.pagesize,
          keyword: this.keyword
        };
      } else {
        params = {
          user_id: this.userid,
          page: this.currentpage,
          page_size: this.pagesize
        };
      }
      switch (this.navtitle) {
        case "问答":
          params.type = 1;
          break;
        case "标注":
          params.type = '2,3';
          break;
      }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      // console.log(params)
      this.$axios
        .get("community/questions", { params })
        .then(function(res) {
          // console.log(res.data)
          that.total_pages = res.data.data.total_pages;
          that.currentpage = res.data.data.current_page;
          if (that.issearch) {
            that.search_count = res.data.data.total_count;
          }
          if (res.data.data.total_count == 0) {
            that.istopask = false;
          } else {
            that.istopask = true;
          }
          // if(that.keyword != ''||that.keyword != null){
          // }else{
          if (res.data.status_code == 200) {
            var imgarr = [];
            for (var j = 0; j < res.data.data.questions.length; j++) {
              imgarr.push(that.bgimg[parseInt(4 * Math.random())]);
            }

            if (that.currentpage == 1) {
              that.questionArr = res.data.data.questions;
              that.imgbg = imgarr;
            } else {
              that.questionArr = that.questionArr.concat(
                res.data.data.questions
              );
              that.imgbg = that.imgbg.concat(imgarr);
            }
            for (var i = 0; i < that.questionArr.length; i++) {
              if (that.questionArr[i].type == 1) {
                if (that.questionArr[i].answer.content.length > 136) {
                  var sub = that.questionArr[i].answer.content.substring(
                    0,
                    136
                  );
                  that.questionArr[i].answer.content = sub;
                }
                if (that.questionArr[i].answer.answer_time) {
                  that.questionArr[i].answer.answer_time = that.questionArr[
                    i
                  ].answer.answer_time.split(" ")[0];
                }
                // if(that.questionArr[i].answer.img){
                //   console.log(that.questionArr[i].answer.detail_content)
                // }
              } else if (that.questionArr[i].type == 2) {
                that.questionArr[i].tag.detail_content =
                  that.questionArr[i].tag.content;
                if (that.questionArr[i].tag.content.length > 136) {
                  var sub = that.questionArr[i].tag.content.substring(0, 136);
                  that.questionArr[i].tag.content = sub;
                }
                if (that.questionArr[i].tag.create_time) {
                  that.questionArr[i].tag.create_time = that.questionArr[
                    i
                  ].tag.create_time.split(" ")[0];
                }
                // that.questionArr[i].tag['is_detail'] = false
              } else if (that.questionArr[i].type == 3) {
                that.questionArr[i].zk_tag.detail_content =
                  that.questionArr[i].zk_tag.content;
                if (that.questionArr[i].zk_tag.content.length > 136) {
                  var sub = that.questionArr[i].zk_tag.content.substring(
                    0,
                    136
                  );
                  that.questionArr[i].zk_tag.content = sub;
                }
                if (that.questionArr[i].zk_tag.create_time) {
                  that.questionArr[i].zk_tag.create_time = that.questionArr[
                    i
                  ].zk_tag.create_time.split(" ")[0];
                }
              }

              that.commentisArr.push(false);
              that.commentArr.push({
                current_page: 1,
                total_pages: 1,
                total_count: 0,
                comments: []
              });
            }


            // console.log(that.questionArr)
            // }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    goquestiondetail(item, num) {
      this.$router.push({
        path: "/questionDetails",
        query: {
          qd: item.question_id,
          a: num
        }
      });
      // let pictureUrl = this.$router.resolve({
      //   path: "/questionDetails",
      //   query: {
      //     qd: item.question_id,
      //     a: num
      //   }
      // });
      // window.open(pictureUrl.href, "_blank");
    },
    tostar(id, index, type) {
      let that = this;
      let params = {
        user_id: this.userid
      };
      let url = "";
      if (type == 1) {
        params.answer_id = id;
        url = "community/" + id + "/star";
      } else {
        params.tag_id = id;
        url = "community/tag/" + id + "/star";
      }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      // console.log(params);
      this.$axios
        .post(url, params)
        .then(function(res) {
          // console.log(res.data)
          if (res.data.status_code == 200) {
            if (type == 1) {
              that.questionArr[index].answer.is_star = true;
              that.questionArr[index].answer.star_count += 1;
            } else {
              that.questionArr[index].tag.is_star = true;
              that.questionArr[index].tag.star_count += 1;
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    cancelstar(id, index, type) {
      let that = this;
      let params = {
        user_id: this.userid
      };
      let url = "";
      if (type == 1) {
        params.answer_id = id;
        url = "community/" + id + "/star";
      } else {
        params.tag_id = id;
        url = "community/tag/" + id + "/star";
      }
      var sign = addstamp(params);
      delete params.token;
      params["sign"] = sign;
      // console.log(params);
      this.$axios.put(url, params).then(function(res) {
        // console.log(res.data)
        if (res.data.status_code == 200) {
          if (type == 1) {
            that.questionArr[index].answer.is_star = false;
            that.questionArr[index].answer.star_count -= 1;
          } else {
            that.questionArr[index].tag.is_star = false;
            that.questionArr[index].tag.star_count -= 1;
          }
        }
      });
    },
    lookmore(index, item) {
      this.questionArr[index].answer.is_detail = !this.questionArr[index].answer
        .is_detail;
    },
    // 点击前一页
    handlePre(val, index, item) {
      if (item.type == 1) {
        this.commentArr[index].current_page = val;
        this.loadlistcomment(index, item.answer.answer_id, item.type);
      } else {
        this.commentArr[index].current_page = val;
        this.loadlistcomment(index, item.tag.tag_id, item.type);
      }
    },
    handleNext(val, index, item) {
      // this.commentArr[index].current_page = val;
      // this.loadlistcomment(index, item.answer.answer_id);
      if (item.type == 1) {
        this.commentArr[index].current_page = val;
        this.loadlistcomment(index, item.answer.answer_id, item.type);
      } else {
        this.commentArr[index].current_page = val;
        this.loadlistcomment(index, item.tag.tag_id, item.type);
      }
    },
    changePage(val, index, item) {
      //   console.log(val);
      // this.commentArr[index].current_page = val;
      // this.loadlistcomment(index, item.answer.answer_id);
      if (item.type == 1) {
        this.commentArr[index].current_page = val;
        this.loadlistcomment(index, item.answer.answer_id, item.type);
      } else {
        this.commentArr[index].current_page = val;
        this.loadlistcomment(index, item.tag.tag_id, item.type);
      }
      //   console.log(this.commentArr[index].current_page);
    }
  },
  watch: {
    isask() {
      if (this.isask) {
        $("body").css({ overflow: "hidden", "margin-right": "17px" });
      } else {
        $("body").removeAttr("style");
      }
    },
    dialogVisible() {
      if (this.dialogVisible) {
        $("body").css({
          overflow: "hidden"
        });
      } else {
        $("body").removeAttr("style");
      }
    }
    // openimg() {
    //   if (this.openimg) {
    //     $("body").css({
    //       overflow: "hidden"
    //     });
    //   } else {
    //     $("body").css({
    //       overflow: "auto"
    //     });
    //   }
    // }
  }
};
</script>

<style scoped lang="scss" type="text/css">
.community {
  width: 900px;
  margin: 0 auto;
  // border: 1px solid red;
  margin-top: 20px;
  .head_box {
    width: 900px;
    height: 42px;
    margin: 0 auto;
    // border: 1px solid red;
    // display: flex;
    // justify-content: space-between;
    .comsearch_content {
      width: 736px;
      height: 40px;
      position: relative;
      display: inline-block;
      .community_search {
        width: 100%;
        height: 100%;
        border: none;
        border-radius: 50px;
        background: #f0f0f0;
        text-indent: 20px;
        outline: none;
        padding-right: 50px;
        font-size: 16px;
        box-sizing: border-box;
        &::placeholder {
          color: #999;
        }
      }
      .search_push {
        width: 60px;
        height: 100%;
        background: url(../../assets/community/search_icon.png) center center
          no-repeat;
        background-size: 20px 20px;
        position: absolute;
        right: 0;
        top: 0;
        // border: 1px solid red;
        border-radius: 0px 50px 50px 0px;
        cursor: pointer;
      }
    }
    .ask {
      width: 118px;
      height: 42px;
      display: inline-block;
      border-radius: 21px;
      background: #d55d3a;
      text-align: center;
      line-height: 42px;
      color: #fff;
      cursor: pointer;
      margin-left: 40px;
      span {
        width: 20px;
        height: 20px;
        display: inline-block;
        background: url(../../assets/community/que_icon.png) center center;
        vertical-align: middle;
        margin-right: 3px;
      }
    }
  }
  .community_content {
    width: 100%;
    // background: #fff;
    margin-top: 30px;
    // margin-bottom: 97px;
    // border: 1px solid red;
    padding-bottom: 60px;
    position: relative;
    .content_head {
      width: 100%;
      height: 55px;
      background: #fff;
      border-bottom: 1px solid #e5e5e5;
      position: relative;
      .head_content {
        width: 115px;
        height: 55px;
        // border: 1px solid red;
        &:hover .head_choice {
          display: block;
        }
      }
      .chioce_head {
        padding-left: 45px;
        height: 55px;
        line-height: 55px;
        display: inline-block;
        color: #d55d3a;
        cursor: pointer;
        // border: 1px solid red;
        span {
          width: 0;
          height: 0;
          display: block;
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 8px solid #e6532c;
          // vertical-align: text-top;
          margin-top: -31px;
          margin-left: 36px;
        }
      }
      .head_choice {
        width: 100px;
        position: absolute;
        top: 52px;
        left: 20px;
        border: 1px solid #dcdcdc;
        display: none;
        li {
          height: 40px;
          font-family: AlibabaPuHuiTi;
          font-weight: 400;
          background: #fff;
          color: #333;
          text-align: center;
          line-height: 44px;
          cursor: pointer;
          &:hover {
            color: #fff;
            background: #e6532c;
          }
        }
      }
    }
    .content_searchhead {
      width: 100%;
      border: 1px solid red;
      background: #fff;
      border: 1px solid transparent;
      line-height: 30px;
      color: #d55d3a;
      font-size: 18px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      box-sizing: border-box;
      padding: 30px;
      padding-bottom: 10px;
      margin-top: 30px;
      cursor: pointer;
      img {
        width: 30px;
        height: 30px;
        vertical-align: middle;
      }
      span {
        color: #d55d3a;
      }
    }
    .questionList {
      background: #fff;
      padding-bottom: 20px;
    }
    .questionli:last-child {
      border-bottom: 0px solid #dcdcdc;
    }
    .questionli {
      width: 847px;
      margin: 0 auto;
      padding-top: 30px;
      border-bottom: 1px solid #dcdcdc;
      .question_li {
        width: 100%;
        .tag_name_detail {
          height: 22px;
          line-height: 22px;
          display: inline-block;
          line-height: 22px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #333;
          margin-bottom: 15px;
          img {
            width: 22px;
            height: 22px;
            display: inline-block;
            vertical-align: top;
            margin-right: 6px;
            border-radius: 50%;
          }
        }
        .tag_bookname {
          color: #999;
          margin-bottom: 15px;
        }
        .tag_bookname2 {
          color: #987659;
          margin-bottom: 15px;
        }
        .tag_content {
          width: 100%;
          // height: 100px;
          margin-bottom: 24px;
          color: #333333;
          img {
            display: block;
            margin: 0 auto;
            margin-bottom: 28px;
            cursor: -moz-zoom-in;
            cursor: -webkit-zoom-in;
            cursor: zoom-in;
          }
        }
        .tag_time {
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          position: absolute;
          top: 43px;
          right: 0;
        }
      }
      .type_t {
        width: 48px;
        height: 24px;
        line-height: 24px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        margin-bottom: 10px;
        color: #fff;
      }
      .tag_t {
        background: #8ca1d5;
      }
      .answer_t {
        background: #ecbf69;
      }
      .questiontitle {
        width: 100%;
        font-size: 20px;
        font-family: PingFangSC-Semibold;
        font-weight: 600;
        color: #333;
        cursor: pointer;
      }
      .iwantanswer {
        width: 117px;
        height: 35px;
        line-height: 35px;
        border-radius: 8px;
        border: 1px solid #d55d3a;
        color: #d55d3a;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        margin-top: 30px;
        margin-bottom: 38px;
        cursor: pointer;
        span {
          width: 20px;
          height: 20px;
          vertical-align: middle;
          display: inline-block;
          margin-top: -4px;
          background: url(../../assets/community/pen_icon.png) center center
            no-repeat;
        }
      }
      .answer_name {
        font-family: PingFangSC-Semibold;
        font-weight: 600;
      }
      .answer_name_detail {
        display: inline-block;
        text-align: center;
        background: rgba(243, 243, 243, 1);
        border-radius: 36px;
        padding: 5px 9px;
        line-height: 24px;
        font-family: PingFang SC;
        font-weight: 600;
        img {
          width: 26px;
          height: 26px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 8px;
          border-radius: 50%;
        }
      }
      .hasanswer {
        width: 100%;
        margin-top: 20px;
        .haspicture {
          width: 100%;
          min-height: 130px;
          // display: flex;
          .hasimage {
            width: 160px;
            height: 106px;
            display: inline-block;
            vertical-align: top;
            cursor: pointer;
          }
          .answercon {
            display: inline-block;
            width: 660px;
            height: 106px;
            box-sizing: border-box;
            margin-left: 20px;
            line-height: 28px;
            cursor: pointer;
          }
          .ishasmore {
            width: 100%;
            cursor: pointer;
          }
        }
      }
      .hasmore {
        color: #d55d3a;
        font-family: PingFangSC-Regular;
        font-weight: 600;
        sub {
          width: 20px;
          height: 20px;
          display: inline-block;
          background: url(../../assets/community/alldown_icon_nor.png) center
            center no-repeat;
        }
        &:hover {
          color: #e83700;
          sub {
            background: url(../../assets/community/alldown_icon_pre.png) center
              center no-repeat;
          }
        }
      }
      .nopicture {
        width: 100%;
        margin-top: 20px;
        margin-bottom: 20px;
        cursor: pointer;
        .nopircontent {
          line-height: 28px;
          width: 100%;
          div {
            display: inline;
            white-space: pre-wrap; /* css3.0 */
            white-space: -moz-pre-wrap; /* Firefox */
            white-space: -pre-wrap; /* Opera 4-6 */
            white-space: -o-pre-wrap; /* Opera 7 */
            word-wrap: break-word;
          }
          span {
            display: inline;
          }
        }

        .nopircontent2 {
          width: 100%;
        }
      }
      .answer_time {
        width: 850px;
        margin: 0 auto;
        margin-bottom: 20px;
        color: #999;
      }
      .answer_evaluate {
        width: 100%;
        height: 24px;
        line-height: 24px;
        color: #ad896b;
        // border: 1px solid red;
        // display: flex;
        margin-bottom: 30px;
        p {
          margin-right: 26px;
          display: inline-block;
          cursor: pointer;
          img {
            vertical-align: middle;
            margin-right: 4px;
          }
          strong {
            width: 24px;
            height: 24px;
            // margin-right: 4px;
            display: inline-block;
            vertical-align: middle;
          }
          &:hover {
            color: #9d7a5c;
          }
        }
        .answer_star {
          .star_span {
            vertical-align: top;
            background: url(../../assets/community/hand_icon_nor.png) center
              center no-repeat;
            // margin-top: -8px;
          }
          &:hover {
            .star_span {
              background: url(../../assets/community/hand_icon_pre.png) center
                center no-repeat;
            }
          }
        }
        .answer_cancelstar {
          img {
            vertical-align: top;
            // margin-top: -2px;
          }
        }
        .answer_comment {
          strong {
            background: url(../../assets/community/com_icon_nor.png) center
              center no-repeat;
          }
          &:hover {
            strong {
              background: url(../../assets/community/com_icon_pre.png) center
                center no-repeat;
            }
          }
        }
        .delete_tag {
          span {
            width: 24px;
            height: 24px;
            display: inline-block;
            background: url(../../assets/community/delete_icon_nor.png) center
              center no-repeat;
            background-size: cover;
            vertical-align: top;
            margin-right: 4px;
          }
          &:hover {
            span {
              background: url(../../assets/community/delete_icon_pre.png) center
                center no-repeat;
              background-size: cover;
            }
          }
        }
        .closeanswer {
          font-size: 16px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: rgba(173, 137, 107, 1);
          line-height: 24px;
          float: right;
          cursor: pointer;
          margin-right: 5px;
          span {
            display: inline-block;
            width: 24px;
            height: 24px;
            vertical-align: top;
            background: url(../../assets/community/Packup_icon_nor.png);
          }
          &:hover {
            color: #9d7a5c;
            span {
              background: url(../../assets/community/Packup_icon_pre.png);
            }
          }
        }
      }
      .answer_comments {
        width: 840px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 8px 0px rgba(6, 5, 4, 0.11);
        border: 1px solid transparent;
        .comment_count {
          margin-top: 20px;
          margin-left: 20px;
          font-family: PingFang SC;
          font-weight: 600;
        }
        .comment_li {
          width: 798px;
          margin: 0 auto;
          border-bottom: 1px solid #e5e5e5;
          padding-top: 20px;
          padding-bottom: 20px;
          position: relative;
          .comment_username {
            font-family: PingFang SC;
            font-weight: 600;
          }
          .comment_comtent {
            width: 712px;
            font-family: PingFang SC;
            font-weight: 400;
            margin-top: 3px;
            white-space: pre-wrap; /* css3.0 */
            white-space: -moz-pre-wrap; /* Firefox */
            white-space: -pre-wrap; /* Opera 4-6 */
            white-space: -o-pre-wrap; /* Opera 7 */
            word-wrap: break-word;
          }
          .comment_time {
            font-family: PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            position: absolute;
            top: 43px;
            right: 0;
            // border: 1px solid red;
          }
          .comment_detele {
            color: #987659;
            margin-top: 10px;
            font-family: PingFang SC;
            font-weight: 400;
            cursor: pointer;
          }
        }
      }
    }
  }
  .notcomment {
    width: 100%;
    height: 20px;
  }
  .comment_answer {
    width: 810px;
    // height: 45px;
    margin: 0 auto;
    position: relative;
    margin-top: 30px;
    margin-bottom: 30px;
    font-size: 18px;
    // display: flex;
    // justify-content: space-around;
    // .comment_input {
    //   width: 700px;
    //   float: left;
    // }
    button {
      width: 98px;
      height: 44px;
      display: inline-block;
      background: rgba(213, 93, 58, 1);
      border-radius: 8px;
      margin-left: 10px;
      border: none;
      color: #fff;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: 400;
      cursor: pointer;
      position: absolute;
      bottom: 0px;
      right: 0px;
    }
  }
  .back {
    width: 70px;
    height: 30px;
    color: #d55d3a;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 12px;
    cursor: pointer;
    span {
      display: inline-block;
      width: 28px;
      height: 28px;
      background: url(../../assets/community/return_icon_nor.png) center center
        no-repeat;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .ask_content {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background: rgba(0, 0, 0, 0.63);
    .closetagbox {
      cursor: pointer;
      // border: 1px solid red;
      width: 30px;
      height: 30px;
      position: absolute;
      top: calc(50% - 190px);
      left: calc(50% + 370px);
      background: url(../../assets/community/close.png) no-repeat center center;
      background-size: 100% 100%;
    }
  }
}

.floatask {
  // border: 1px solid red;
  width: 70px;
  height: 115px;
  margin-left: 20px;
  position: sticky;
  bottom: 20px;
  margin-left: 960px;
  margin-top: -117px;
  .iwantask {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #d55d3a;
    border: 1px solid transparent;
    cursor: pointer;
    position: relative;
    p {
      width: 32px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 16px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
      margin: 0 auto;
    }
  }
  .gotop {
    width: 24px;
    height: 24px;
    margin: 0 auto;
    margin-top: 20px;
    cursor: pointer;
    background: url(../../assets/community/Top_icon_nor.png);
    &:hover {
      background: url(../../assets/community/Top_icon_hover.png);
    }
  }
}
.iwantask_search {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: #d55d3a;
  border: 1px solid transparent;
  cursor: pointer;
  position: fixed;
  margin-left: 1000px;
  bottom: 220px;
  p {
    width: 32px;
    font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 22px;
    margin: 0 auto;
    margin-top: 13px;
  }
}
.img_open {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  /* border: 1px solid red; */
  background: rgba(26, 26, 26, 0.65);
  border-radius: 6px;
  padding-bottom: 10px;
  .openimg_img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    margin: 0 auto;
    cursor: -moz-zoom-out;
    cursor: -webkit-zoom-out;
    cursor: zoom-out;
  }
}
.dialog {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 999;
  .dialog_center {
    width: 400px;
    height: 210px;
    border-radius: 6px;
    background: #fff;
    position: absolute;
    top: calc(50% - 105px);
    left: calc(50% - 200px);
    // box-shadow: 0 0 0 999px rgba(0, 0, 0, 0.3);
    .dialogtitle {
      font-size: 24px;
      color: #333;
      margin-top: 50px;
      text-align: center;
      font-weight: bold;
    }
    .dialogconfirm {
      margin-top: 60px;
      display: flex;
      justify-content: space-around;
      p {
        line-height: 40px;
        text-align: center;
        border-radius: 6px;
        font-size: 20px;
        cursor: pointer;
        font-family: AlibabaPuHuiTiR;
      }
      .dialogfalse {
        width: 143px;
        height: 38px;
        border: 1px solid rgba(220, 220, 220, 1);
        // box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
        transition: transform 0.15s;
        // text-shadow: 1px 2px 1px rgba(77, 9, 36, 0.6);
        &:active {
          transform: translate(0, 1px) !important;
          transition: transform 0.15s ease;
          animation: input-shadow 0.15s ease;
          // box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
        }
      }
      .dialogtrue {
        width: 145px;
        height: 40px;
        background: linear-gradient(
          45deg,
          rgba(255, 124, 90, 1),
          rgba(230, 82, 43, 1)
        );
        color: #fff;
        // box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 2px 4px -1px rgba(0, 0, 0, 0.3);
        transition: transform 0.15s;
        // text-shadow: 1px 2px 1px rgba(77, 9, 36, 0.6);
        &:active {
          transform: translate(0, 1px) !important;
          transition: transform 0.15s ease;
          animation: input-shadow 0.15s ease;
          // box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.14), 0 1px 7px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -1px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
}
</style>
<style>
.detail_content {
  width: 100%;
  /* border: 1px solid red; */
  line-height: 36px;
  font-size: 16px;
  white-space: pre-wrap; /* css3.0 */
  white-space: -moz-pre-wrap; /* Firefox */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: -o-pre-wrap; /* Opera 7 */
  word-wrap: break-word;
}
.questionli .detail_content p {
  width: 100%;
}
.questionli .detail_content img {
  display: block;
  margin: 0 auto;
  max-width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: -moz-zoom-in;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}
.answer_comments .pagination {
  margin: 10px auto 30px;
  width: 100%;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 400;
}
.answer_comments .el-pagination button:hover {
  color: #d55d3a;
}

.el-pagination button:disabled:hover {
  color: #c0c4cc;
}
.answer_comments .el-icon-arrow-left:before,
.answer_comments .el-icon-arrow-right:before {
  /* content: "上一页"; */
  font-size: 16px;
}
.answer_comments .el-pager li.active,
.el-pager li:hover,
.answer_comments .el-icon-arrow-left:hover,
.answer_comments .el-icon-arrow-right:hover {
  color: #d55d3a;
}
.comment_input .el-textarea__inner {
  width: 700px;
  padding-top: 10px;
  background: #f3ede9;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  /* text-indent: 22px; */
  color: #333;
  outline: none;
}
.comment_input .el-textarea__inner::placeholder {
  color: #a8978c;
}
</style>


// WEBPACK FOOTER //
// src/components/page/community.vue